import { EntityDropdownProps } from "#batteries-included-components/Dropdowns/EntityDropdownInput";
import { DropdownInput } from "@validereinc/common-components";
import { DeviceStatusType } from "@validereinc/domain";
import { Devices } from "@validereinc/domain-controllers";
import React from "react";

const { DeviceStatusOptions } = Devices.view;

export const DeviceStatusDropdownInput = ({
  name = "status",
  label,
  ...props
}: EntityDropdownProps<DeviceStatusType>) => {
  return (
    <DropdownInput
      label={label ?? "Status"}
      name={name}
      options={DeviceStatusOptions}
      labelKey="label"
      valueKey="value"
      {...props}
    />
  );
};
